var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"btn btn-outline-info",attrs:{"to":_vm.getBackUrl()},nativeOn:{"click":function($event){return _vm.cancel($event)}}},[_c('span',{staticClass:"fa fa-arrow-left"})])}
var staticRenderFns = []

export { render, staticRenderFns }